import React from 'react';
//import { useNavigate } from "react-router-dom";


import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';
import userData from '../../static/userData.json'
import { clearNavNowLocalAnchor, crypt } from '../../services/common.utils';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_SELECTED_LOGIN_DATA = 'UPDATE_SELECTED_LOGIN_DATA'

export function signupAction(email, password, navigate) {

    return (dispatch) => {
        signUp(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    //history,
                );
                dispatch(confirmedSignupAction(response.data));
                navigate('/dashboard');
                //history.push('/dashboard');
            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

export function Logout(navigate) {
    navigate('/login');
    setTimeout(() => {
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userDetailsAll');
        localStorage.removeItem('selectedLoginData');
        localStorage.removeItem('canShowCleaningBtn');
        localStorage.removeItem('next_shift');
        localStorage.removeItem('elapsedTime');
        clearNavNowLocalAnchor();
    }, 1000)
    //history.push('/login');

    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, navigate) {
    return (dispatch) => {
        login(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                  5, // response.data.expiresIn * 1000,
                    navigate,
                );

                // console.log(response.data)
                let myData = response?.data[0]
                // let staticData = {...userData}
                let staticData = {
                    "localId": crypt(email),
                    "displayName": myData?.resource_first + ' ' + myData?.resource_last,
                    "idToken": crypt(myData?.resources_id),
                    "registered": true,
                    "refreshToken": crypt(email),
                }
                // console.log(staticData)
                dispatch(loginConfirmedAction(staticData));
                            
                navigate('/dashboard');
            })
            .catch((error) => {
                //console.log('error');
                //console.log(error);
                const errorMessage = formatError(error.response.data);
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export function updateUserData(data){
    return {
        type: UPDATE_USER_DATA,
        payload: data,
    };
}

export function updateSelectedLoginData(data){
    return {
        type: UPDATE_SELECTED_LOGIN_DATA,
        payload: data,
    };
}
